export function getInitials(fullName: string) {
  const nameParts = fullName.split(' ');

  const initials = nameParts.map((part) => part.charAt(0).toUpperCase()).join('');

  return initials;
}
